// @ts-ignore
import Logo from '../public/logo-dark-full.png';

export const StagesetLogoFull = (): JSX.Element => (
  <img height={80} src={Logo} alt="" />
);
